
// @ts-nocheck
import {
  readGetSmokeByReport,
} from "@/store/performance/getters";
import { Options, Vue } from "vue-class-component";
import { store } from "@/store";
import CryptoJS from "crypto-js";
import { ElImageViewer } from "element-plus"; // 确保已正确安装并导入element-plus
import { ElMessage } from "element-plus";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import { dateConversion, getLocalProject, typeConversion } from "@/utils";
import axios from 'axios'
import Konva from "konva";

export default class TaskRecord extends Vue {
  /* 数据导入 */
    dialogImportVisible = false
    fileList = []

    onImportData() {
      this.fileList = []
      this.dialogImportVisible = true
    }
    handleChange(file) {
      this.fileList[0] = file
    }
    handleImportExceed(files) {
      this.$refs?.importFileRef?.clearFiles()
      this.$refs?.importFileRef?.handleStart(files[0])
    }
    onImportRemove() {
      this.fileList = []
    }
    async onSubmitImportFile() {
      if (!this.fileList[0]) {
        return ElMessage.warning('请选择zip文件')
      }
      const data = new FormData
      data.append('project', Number(getLocalProject()))
      data.append('file', this.fileList[0].raw)
      await axios.post('report/light_smoke/', data)
      this.dialogImportVisible = false
      ElMessage.success('上传成功')
    }
  /**/

  /* 换图功能 */
    changePicDialogVisible = false
    changeFileList = []
    curPic = {
      id: '',
      image: '',
    }

    onIconChange(uploadFile) {
      this.changeFileList[0] = uploadFile
    }

    handleExceed(files) {
      this.$refs?.uploadRef?.clearFiles()
      this.$refs?.uploadRef?.handleStart(files[0])
    }

    onChangePic(pic) {
      this.changePicDialogVisible = true
      this.changeFileList = []
      this.curPic = pic
    }

    async changePic() {
      if (!this.changeFileList[0]) {
        return ElMessage.warning('请选择图片')
      }

      const data = new FormData
      data.append('project', Number(getLocalProject()))
      data.append('file', this.changeFileList[0].raw)
      data.append('id', this.curPic.id)
      data.append('image', this.curPic.image)

      await axios.put('report/light_smoke_image/', data)
      this.changePicDialogVisible = false
      //this.confirm(false)
      location.reload()
    }
  /**/

  /* 图片放大功能 */
    public async leftBtn(data) {
      this.img_loading = true;
      this.find_index = this.find_index - 1;
      console.log(this.find_index);
      if (this.find_index == 0) {
        this.leftShow = "";
      } else {
        this.leftShow = "el-icon-arrow-left";
      }
      this.rightShow = "el-icon-arrow-right";
      // await this.confirm(false);

      this.mask.img = `https://gr.woa.com${this.mask.img_list[this.find_index]}`

      this.mask.mark = this.smoke_list.data[this.smoke_list.version_list[this.find_index]][
        this.mask.name
      ];
      this.problem_img_list = this.mask.ai_check_all[this.find_index];
      this.radio1 = this.mask.ai_check_res_all[this.find_index];
      // this.mask.mark = this.smoke_list.data[this.version_list[this.find_index]][
      //   this.mask.name
      // ];
      // this.mask.mark_all_list[this.find_index]=this.previewImages[0].data.mark_all_list[this.find_index]
      this.stage = null;
      this.isDrawing = false;
      this.rect = null;

      this.num++;

      setTimeout(() => {
        this.initializeKonva();
      });
    }
    
    public async rightBtn(data) {
      this.find_index = this.find_index + 1;
      this.img_loading = true;
      if (this.find_index == this.mask.img_list.length - 1) {
        this.rightShow = "";
      } else {
        this.rightShow = "el-icon-arrow-right";
      }
      this.leftShow = "el-icon-arrow-left";

      this.mask.img = `https://gr.woa.com${this.mask.img_list[this.find_index]}`

      console.log('this.mask.img_list', this.mask.img_list)

      // await this.confirm(false);
      console.log(this.smoke_list, this.version_list, this.find_index)
      console.log('this.mask.name', this.mask.name)

      

      this.mask.mark = this.smoke_list.data[this.smoke_list.version_list[this.find_index]][
        this.mask.name
      ]
      console.log('this.mask.mark', this.mask.mark, this.mask.img)


      this.problem_img_list = this.mask.ai_check_all[this.find_index];
      this.radio1 = this.mask.ai_check_res_all[this.find_index];

      this.num++;
      this.stage = null;
      this.isDrawing = false;
      this.rect = null;
      setTimeout(() => {
        this.initializeKonva();
      });
    }

    public async imgBtn(
      data,
      data_list,
      index_img,
      version,
      posName?,
      row_index?
    ) {
      this.mask.row_index = row_index;
      this.showMask = true;
      this.img_loading = true;
      this.mask.img = `https://gr.woa.com${data}`;

      this.mask.img_list = data_list;

      this.find_index = index_img;
      // await this.confirm(false);
      console.log('this.newData', this.newData)
      console.log('posName', posName)

      this.mask.mark_all_list = this.newData.filter(
        (v) => v.name == posName
      )[0].mark_all_list;
      this.mask.location_list_all_list = this.newData.filter(
        (v) => v.name == posName
      )[0].location_list_all_list;

      this.mask.ai_check_all = this.newData.filter(
        (v) => v.name == posName
      )[0].ai_check_all;

      this.mask.ai_check_res_all = [
        ...this.table_list_data.filter((v) => v.name == posName)[0]
          .ai_check_res_all,
      ];
      this.mask.mark = this.newData.filter((v) => v.name == posName)[0][version][
        posName
      ];

      console.log('this.mask.mark', this.mask.mark)

      this.problem_img_list = this.mask.ai_check_all[this.find_index];
      this.radio1 = this.mask.ai_check_res_all[this.find_index];
      this.mask.mask = this.previewImages[0].data.mark_all_list[index_img];
      // this.mask.mark = this.smoke_list.data["0.1.0.27664.0@569096"][
      //   '{"Position": [{"X": 977.723450, "Y": 6059.745605, "Z": -36332.800781}]}_{"Rotation": [{"P": 0.410269, "Y": 230.061325, "R": 0.000038}]}|C02_StormFortress|小米10|15:00'
      // ];
      // console.log(this.newData)
      // this.mask.mark_all_list = this.newData.filter(
      //   (v) =>
      //     v.name ==
      //     '{"Position": [{"X": 977.723450, "Y": 6059.745605, "Z": -36332.800781}]}_{"Rotation": [{"P": 0.410269, "Y": 230.061325, "R": 0.000038}]}|C02_StormFortress|小米10|15:00'
      // )[0].mark_all_list;
      // this.mask.location_list_all_list = this.newData.filter(
      //   (v) =>
      //     v.name ==
      //     '{"Position": [{"X": 977.723450, "Y": 6059.745605, "Z": -36332.800781}]}_{"Rotation": [{"P": 0.410269, "Y": 230.061325, "R": 0.000038}]}|C02_StormFortress|小米10|15:00'
      // )[0].location_list_all_list;
      // console.log( this.mask.location_list_all_list )
      // console.log(this.mask.mark_all_list)

      // console.log(this.mask.mark);
      this.mask.name = posName;
      this.mask.version = version;

      if (this.find_index == 0) {
        this.leftShow = "";
      } else {
        this.leftShow = "el-icon-arrow-left";
      }
      if (this.find_index == this.mask.img_list.length - 1) {
        this.rightShow = "";
      } else {
        this.rightShow = "el-icon-arrow-right";
      }
      this.num++;
      this.$nextTick(() => {
        const maskBoxWidth = (this.$refs.mask_box as any).clientWidth;
        const buttonWidth = 54 * 2; // 两个按钮的总宽度
        this.canvasWidth = maskBoxWidth - buttonWidth;
        setTimeout(() => {
          this.initializeKonva();
        });
      });
    }
  /**/

  /* 画框 */
    public leftShow = "el-icon-arrow-left";
    public rightShow = "el-icon-arrow-right";
    public num = 0;
    public stageWidth = 0;
    public stageHeight = 0;
    public rect = null;
    public isDrawing = false;
    public startX = 0;
    public startY = 0;
    public canvasWidth = 0;
    public canvasHeight = 0;
    public renderDefaultRectangles(scale) {
      var canvasWidth = this.layer.width();
      var canvasHeight = this.layer.height();

      console.log('this.mask.mark_all_list', this.mask.mark_all_list)
      console.log('find_index', this.find_index)
      this.mask.mark_all_list[this.find_index]?.forEach((data) => {
        var defaultRect = new Konva.Rect({
          // x: ((data.x)/this.originalWidth) * canvasWidth,
          // y: ((data.y)/this.originalHeight) * canvasHeight,
          // width: ((data.width)/this.originalWidth) * canvasWidth,
          // height: ((data.height)/this.originalHeight) * canvasHeight,
          x: data.x * canvasWidth,
          y: data.y * canvasHeight,
          width: data.width * canvasWidth,
          height: data.height * canvasHeight,
          new_x: data.new_x,
          new_y: data.new_y,
          new_width: data.new_width,
          new_height: data.new_height,
          stroke: "red",
          strokeWidth: 2,
          fill: "transparent",
        });

        this.layer.add(defaultRect);
      });
      this.mask.location_list_all_list[this.find_index]?.forEach((data) => {
        var defaultRect = new Konva.Rect({
          // x: ((data.x)/this.originalWidth) * canvasWidth,
          // y: ((data.y)/this.originalHeight) * canvasHeight,
          // width: ((data.width)/this.originalWidth) * canvasWidth,
          // height: ((data.height)/this.originalHeight) * canvasHeight,
          x: data.x * canvasWidth,
          y: data.y * canvasHeight,
          width: data.width * canvasWidth,
          height: data.height * canvasHeight,
          new_x: data.new_x,
          new_y: data.new_y,
          new_width: data.new_width,
          new_height: data.new_height,
          stroke: "yellow",
          strokeWidth: 2,
          fill: "transparent",
        });

        this.layer.add(defaultRect);
      });
      this.layer.draw();
    }
    public layer = null;
    public defaultRectangles = [];
    public stage = null;
    public originalWidth = 0;
    public originalHeight = 0;
    public page = 1;
    public size = 20;

    initializeKonva() {
      const imgElement: any = this.$refs.image;

      if (this.stage) {
        this.stage.destroy();
        this.stage = null;
      }
      imgElement.onload = () => {
        this.originalWidth = imgElement.naturalWidth;
        this.originalHeight = imgElement.naturalHeight;
        const aspectRatio = this.originalWidth / this.originalHeight;

        // 设置目标宽度为1600px
        this.canvasHeight = this.canvasWidth / aspectRatio;
        // var originalWidth = imageObj.width;
        // var originalHeight = imageObj.height;

        var scaledHeight = 1600 / aspectRatio;
        this.stage = new Konva.Stage({
          container: this.$refs.container as any,
          width: this.canvasWidth,
          height: this.canvasHeight,
        });

        this.layer = new Konva.Layer();
        this.stage.add(this.layer);

        var konvaImage = new Konva.Image({
          x: 0,
          y: 0,
          image: imgElement,
          width: this.canvasWidth,
          height: this.canvasHeight,
        });
        this.layer.add(konvaImage);
        this.layer.draw();

        // 渲染默认矩形
        this.$nextTick(() => {
          this.renderDefaultRectangles(this.canvasWidth / this.originalWidth);
        });

        this.img_loading = false;
        if (this.stage) {
          this.stage.on("mousedown", this.handleMouseDown);
          this.stage.on("mousemove", this.handleMouseMove);
          this.stage.on("mouseup", this.handleMouseUp);
        }
      };
      // imageObj.src = this.mask.img;
      if (imgElement.complete) {
        imgElement.onload();
      }

      // 事件监听器
    }
    //               initializeKonva() {

    //                 this.stage = new Konva.Stage({
    //     container: this.$refs.container as any,
    //     width: 1600,
    //     height: 800
    // });

    //   this.layer = new Konva.Layer();
    //   this.stage.add(this.layer);

    //   var imageObj = new Image();
    //   imageObj.onload = () => {
    //     var originalWidth = imageObj.width;
    //     var originalHeight = imageObj.height;
    //     var aspectRatio = originalWidth / originalHeight;
    //     var scaledHeight = 1600 / aspectRatio;

    //     var konvaImage = new Konva.Image({
    //       x: 0,
    //       y: 0,
    //       image: imageObj,
    //       width: 1600,
    //       height: scaledHeight
    //     });
    //     this.layer.add(konvaImage);
    //     this.layer.draw();

    //     // 渲染默认矩形
    //     this.renderDefaultRectangles();
    //   };
    //   imageObj.src = this.mask.img;

    //   // 事件监听器
    //   this.stage.on('mousedown', this.handleMouseDown);
    //   this.stage.on('mousemove', this.handleMouseMove);
    //   this.stage.on('mouseup', this.handleMouseUp);
    //             }

    handleMouseDown(e) {
      this.isDrawing = true;
      var pos = this.stage.getPointerPosition();
      this.startX = pos.x;
      this.startY = pos.y;

      this.rect = new Konva.Rect({
        x: this.startX,
        y: this.startY,
        width: 0,
        height: 0,
        stroke: "red",
        strokeWidth: 2,
        fill: "transparent",
      });
      this.layer.add(this.rect);
    }
    handleMouseUp(e) {
      this.isDrawing = false;
      var canvasWidth = this.layer.width();
      var canvasHeight = this.layer.height();

      var newRectData = {
        x: this.rect.x() / canvasWidth,
        y: this.rect.y() / canvasHeight,
        width: this.rect.width() / canvasWidth,
        height: this.rect.height() / canvasHeight,
        // x: (this.rect.x()/canvasWidth)*this.originalWidth,
        // y: (this.rect.y()/canvasHeight) *this.originalHeight,
        //   width: (this.rect.width() / canvasWidth)*this.originalWidth,
        // height: (this.rect.height() / canvasHeight)*this.originalHeight,
        new_x: this.rect.x(),
        new_y: this.rect.y(),
        new_width: this.rect.width(),
        new_height: this.rect.height(),
      };

      console.log('this.mask.mark_all_list', this.mask.mark_all_list)
      this.mask.mark_all_list[this.find_index].push(newRectData);
      this.sendRectanglesToServer();
    }

    dispatchPutLightSmoke(data) {
      return axios.put(`report/light_smoke/`, data)
    }

    sendRectanglesToServer() {
      let filteredData = this.mask.mark_all_list[this.find_index].filter(
        (item) => item.width !== 0 && item.height !== 0
      );
      this.dispatchPutLightSmoke({
        project: Number(getLocalProject()),
        id: this.mask.mark.id,
        index: this.mask.mark.index,
        result: this.mask.mark.result,
        remark: this.mask.mark.remark,
        bug_url: this.mask.mark.bug_url,
        problem_type:
          this.mask.mark.result == "通过" || this.mask.mark.result == "未测试"
            ? ""
            : this.mask.mark.problem_type,
        light_type: 0,
        mark: filteredData,
        ai_check: this.mask.ai_check_all[this.find_index],
        // ai_check_res:this.mask.ai_check_res_all[this.find_index]
      });
      this.newData.forEach((v, index) => {
        if (v.name == this.mask.name) {
          v.mark_all_list = this.mask.mark_all_list;
        }
      });
    }
    handleMouseMove(e) {
      if (!this.isDrawing) return;
      var pos = this.stage.getPointerPosition();
      var width = pos.x - this.startX;
      var height = pos.y - this.startY;
      this.rect.width(Math.abs(width));
      this.rect.height(Math.abs(height));
      this.rect.x(width < 0 ? pos.x : this.startX);
      this.rect.y(height < 0 ? pos.y : this.startY);
      this.layer.draw();
    }
    drawRectangle() {
      const img = (this.$refs.mask_box as any).querySelector("img");
      const width = img.clientWidth;
      const height = img.clientHeight;

      const stage = new Konva.Stage({
        container: this.$refs.container as any,
        width: width,
        height: height,
      });

      const layer = new Konva.Layer();
      console.log(layer);
      stage.add(layer);

      const rect = new Konva.Rect({
        x: 50, // X coordinate of the rectangle
        y: 50, // Y coordinate of the rectangle
        width: 100, // Width of the rectangle
        height: 100, // Height of the rectangle
        fill: "red",
        stroke: "black",
        strokeWidth: 2,
      });

      layer.add(rect);
      layer.draw();
    }

    public deleteCanvas() {
      this.isDrawing = false;
      this.stage = null;
      this.rect = null;
      this.mask.mark_all_list[this.find_index] = [];
      setTimeout(() => {
        this.initializeKonva();
        this.sendRectanglesToServer();
      });
    }
  /**/


  formData = {
    dateVersion: ''
  }
  getCurRowData(scope, device) {
    const data = this.smoke_list?.data?.[device]?.[scope.row.name]
    return data
  }
  //newVersionList = []


  get curDate() {
    return this.formData.dateVersion.split('&')[1]
  }
  get curVersion() {
    return this.formData.dateVersion.split('&')[0]
  }

  public img_list = [];
  // 部分列表字段其他字段在template里直接定义了)
  public TaskFields = [
    { label: "开始时间", prop: "start" },
    { label: "结束时间", prop: "end" },
    { label: "执行者", prop: "create_user" },
  ];
  public testData = 1;
  public ai_check_res_all: any = [[], [], []];
  public async radioChange() {
    this.mask.ai_check_res_all[this.find_index] = this.radio1;
    // this.mask.ai_check_res_all.splice(this.find_index, 1, this.radio1);
    // console.log( this.mask.ai_check_res_all)
    // this.testData=this.radio1
    //  this.ai_check_res_all[this.find_index]=this.testData
    //  this.mask.ai_check_res_all=this.ai_check_res_all
    this.table_list_data.forEach((v, index) => {
      if (v.name == this.mask.name) {
        v.ai_check_res_all = this.mask.ai_check_res_all;
      }
    });
    await this.dispatchPutLightSmoke({
      project: Number(getLocalProject()),
      id: this.mask.mark.id,
      index: this.mask.mark.index,
      result: this.mask.mark.result,
      remark: this.mask.mark.remark,
      bug_url: this.mask.mark.bug_url,
      problem_type:
        this.mask.mark.result == "通过" || this.mask.mark.result == "未测试"
          ? ""
          : this.mask.mark.problem_type,
      light_type: 0,
      mark: this.mask.mark_all_list[this.find_index].filter(
        (item) => item.width !== 0 && item.height !== 0
      ),
      ai_check: this.mask.ai_check_all[this.find_index],
      ai_check_res: this.mask.ai_check_res_all[this.find_index],
    });
  }
  
  public handleWheel(event) {
    // 判断滚轮方向
    event.preventDefault();
    const delta = Math.sign(event.deltaY);

    // 根据滚轮方向调整缩放比例
    if (delta > 0) {
      // 向下滚动，缩小图片
      this.scale -= 0.1;
    } else {
      // 向上滚动，放大图片
      this.scale += 0.1;
    }

    // 限制最小和最大缩放比例
    this.scale = Math.max(0.1, Math.min(3, this.scale));
  }
  // 其他方法如 leftBtn、rightBtn1 保持不变
  public get leftButtonPosition() {
    // 计算左侧按钮的位置，使其跟随图片缩放
    return `${20 * this.scale}px`;
  }
  public get rightButtonPosition() {
    console.log(this.scale);
    // 计算右侧按钮的位置，使其跟随图片缩放
    return `${20 * this.scale}px`;
  }
  public scale = 1;
  public activePreviewList = [];
  public add_version = "";
  public add_show = false;
  public activePreviewIndex = 0;
  public configShow = false;
  public bugModel = "";
  public only_no_pass = false;
  public tableLoading = false;
  public showMask = false;
  public previewImages = [
    {
      data: {
        img: {
          8: require("../../assets/test/222.png"),
          6: require("../../assets/test/222.png"),
          5: require("../../assets/test/222.png"),
          4: require("../../assets/test/222.png"),
        },
        little: {
          8: require("../../assets/test/11.jpg"),
          6: require("../../assets/test/14.jpg"),
          5: require("../../assets/test/17.jpg"),
          4: require("../../assets/test/18.jpg"),
        },
        imgtest_list: [
          require("../../assets/test/222.png"),
          require("../../assets/test/10.jpg"),
          require("../../assets/test/8.jpg"),
          require("../../assets/test/24.jpg"),
        ],
        mark_all_list: [[], [], []],
        mark: [],
      },
    },
    // require("../../assets/test/10.jpg"),
    // require("../../assets/test/8.jpg"),
    // require("../../assets/test/24.jpg"),
  ];
  public mask: any = {
    img: "",
    img_list: [],
    mark_all_list: [],
    mark: {},
    name: "",
    version: "",
    ai_check_all: [],
    ai_check_res_all: [],
    row_index: 0,
    location_list_all_list: [],
  };
  public problem_img_list = [];
  public radio1 = -1;
  public find_index = 0;
  public img_loading = false;
  radioClass(label) {
    if (this.radio1 === -1) return "radio-default"; // 未选中
    return this.radio1 === label ? "radio-correct" : "radio-default";
  }
  
  public imgtest_list = [
    require("../../assets/test/6.jpg"),
    require("../../assets/test/10.jpg"),
    require("../../assets/test/8.jpg"),
    require("../../assets/test/24.jpg"),
  ];
  maskBtn(ev) {
    if (!(this.$refs.mask_box as any).contains(ev.target)) {
      this.showMask = false;
    }
  }
  public list = [8, 6, 5, 4];
  handlePreview(imgList, targetImg) {
    const index = imgList.indexOf(targetImg);
    (this as any).$preview({
      urlList: imgList,
      initialIndex: 2, // 确保正确的初始预览图片
    });
  }
  public handleClickItem(event) {
    var imgElement = event.target;
    var originalSrc = imgElement.getAttribute("data-src");
    var thumbnailSrc = imgElement.src;
    if (originalSrc) {
      imgElement.src = originalSrc;
      imgElement.removeAttribute("data-src");
    }

    this.$nextTick(() => {
      setTimeout(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          (document.querySelector(".el-image-viewer__close") as any).click();
        });

        // 添加关闭事件监听器
        const closeButton = document.querySelector(".el-image-viewer__close");
        if (closeButton) {
          closeButton.addEventListener("click", () => {
            // 关闭遮罩层后，重新设置img元素的src属性为缩略图的URL
            imgElement.src = thumbnailSrc;
          });
        }
      }, 500); // 等待500毫秒后执行
    });
  }
  public clickTimer = null;
  handleClick(item, event) {
    if (this.clickTimer) {
      clearTimeout(this.clickTimer);
      this.clickTimer = null;
      this.bug_edit(item, event);
    } else {
      this.clickTimer = setTimeout(() => {
        this.navigateTo(item.bug_url);
        this.clickTimer = null;
      }, 250); // 250ms 是双击检测的延迟时间，可以根据需要调整
    }
  }
  public debug(data) {
    console.log(data != "", data, "排错");
  }
  public bug_edit(data, event) {
    event.preventDefault(); // 阻止<a>标签默认行为
    this.configShow = true;

    this.bugModel = data.bug_url;
    this.add_bug_data = data;
  }
  public add_bug_data: any = {};
  public problem_list = [
    "场景构建/烘焙失败",
    "场景大面积死黑",
    "场景局部偏黑",
    "场景大面积曝光",
    "场景反射异常",
    "场景直线光漏光",
    "场景资产偏黑",
    "场景地形偏黑",
    "场景灯光偏黑",
    "场景资产偏曝",
    "场景灯光偏亮",
    "场景灯光偏曝",
    "场景灯光Fog切换异常",
  ];
  public problem_check_list = [
    { name: "ALL", value: "" },
    {
      name: "AI正常",
      value: 0,
    },
    {
      name: "AI异常",
      value: 1,
    },
  ];
  public ai_check = "";
  public add_bug(data, image) {
    if (!image) {
      return;
    }
    this.configShow = true;
    this.bugModel = "";
    this.add_bug_data = data;
  }
  public htmlZip = "";
  public navigateTo(url) {
    window.open(url, "_blank");
  }
  openPreview() {
    this.activePreviewList = this.previewImages;
  }
  public editing = {
    row: null,
    column: null,
    type: null,
  };

  dispatchLightSmokeHtmltExport(params) {
    return axios('report/html_export/', {params, headers:{'Content-Type': 'application/zip'}, responseType: 'blob'})
  }

  public async exportBtn() {
    let b = (this as any).$message({
      //Message 消息提示
      message: "导出中,请耐心等待....",
      showClose: true,
      duration: 0,
    });
    const versionDate = (this.formData.dateVersion as string)?.split('&')
    this.dispatchLightSmokeHtmltExport({
      project: Number(getLocalProject()),
      scene: this.scene,
      device: this.device,
      version_list: this.version_list,
      tod: this.tod,
      only_no_pass: this.only_no_pass ? "yes" : "",
      light_type: 0,
      test_result: this.test_result,
      problem_type: this.problem_type,
      version: versionDate[0],
    })
      .then((response) => {
        const blob = response;

        // 创建一个指向Blob对象的URL
        const url = URL.createObjectURL(blob);

        // 创建一个<a>标签
        const link = document.createElement("a");

        // 将<a>标签的href属性设置为Blob对象的URL
        link.href = url;

        // 设置下载的文件名

        link.download = `${this.scene}-${this.device}-${this.tod}.zip`; // 设置下载文件的名称
        // 将<a>标签添加到DOM中（这样才能触发点击事件）
        document.body.appendChild(link);

        // 触发点击事件以下载文件
        link.click();

        // 从DOM中移除<a>标签
        document.body.removeChild(link);

        // 释放URL对象，避免内存泄漏
        URL.revokeObjectURL(url);
        ElMessage.success({
          message: "导出成功",
          showClose: true,
          type: "success",
        });
        b.close();
      })
      .catch((error) => {
        b.close();
        ElMessage.error({
          message: "导出失败",
          showClose: true,
          type: "error",
        });
      });
  }

  dispatchLightSmokeOLhtmlExport(params) {
    return axios('report/online_html_export/', {params})
  }

  public async exportBtnOl() {
    let b = (this as any).$message({
      //Message 消息提示
      message: "导出中,请耐心等待....",
      showClose: true,
      duration: 0,
    });
    const versionDate = (this.formData.dateVersion as string)?.split('&')
    this.dispatchLightSmokeOLhtmlExport({
      project: Number(getLocalProject()),
      scene: this.scene,
      device: this.device,
      version_list: this.version_list,
      tod: this.tod,
      only_no_pass: this.only_no_pass ? "yes" : "",
      light_type: 0,
      test_result: this.test_result,
      problem_type: this.problem_type,
      version: versionDate[0],
    })
      .then((htmlContent) => {
        const blob = new Blob([htmlContent], { type: "text/html" });

        // 创建一个指向 Blob 对象的 URL
        const url = URL.createObjectURL(blob);

        // 创建一个临时的 <a> 标签
        const link = document.createElement("a");
        link.href = url; // 设置链接为 Blob URL
        link.download = `${this.scene}-${this.device}-${this.tod}.html`; // 设置下载文件的名称
        link.style.display = "none"; // 隐藏 <a> 标签

        // 将 <a> 标签添加到 DOM 中
        document.body.appendChild(link);

        // 触发点击事件以开始下载
        link.click();

        // 从 DOM 中移除 <a> 标签
        document.body.removeChild(link);

        // 释放 Blob URL
        URL.revokeObjectURL(url);
        ElMessage.success({
          message: "导出成功",
          showClose: true,
          type: "success",
        });
        b.close();
      })
      .catch((error) => {
        b.close();
        ElMessage.error({
          message: "导出失败",
          showClose: true,
          type: "error",
        });
      });
  }

  public deleteBtn(item) {
    (this as any)
      .$confirm("隐藏当前列, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        // 在这里执行删除操作，例如调用 API
        const index = this.version_list.indexOf(item);
        if (index > -1) {
          this.version_list.splice(index, 1);
        }
        this.confirm(false);
        (this as any).$message({
          type: "success",
          message: "隐藏成功!",
        });
      })
      .catch(() => {
        (this as any).$message({
          type: "info",
          message: "已取消",
        });
      });
  }

  public add_btn() {
    this.version_list.push("");
    this.version_list[this.version_list.length - 1] = this.add_version;
    this.add_show = false;
    this.confirm(false);
  }
  public addBtn() {
    this.add_version = "";
    this.add_show = true;
    // this.version_list.push('')
  }

  smoke_scene_list = []
  async dispatchLightSmokeScenes(params) {
    const {data} = await axios.get(`/report/light_smoke_scenes/`, {params})
    this.smoke_scene_list = data
  }

  public smoke_scnes_api() {
    return this.dispatchLightSmokeScenes({
      project: Number(getLocalProject()),
      light_type: 0,
    });
  }
  public mergeCells2({ row, column, rowIndex, columnIndex }) {
    //   if(this.only_no_pass){
    //      if (columnIndex === 0||columnIndex === 1||columnIndex === 2||columnIndex === 3) {
    //   const rowCount = this.newData.filter((item) => item.name === row.name)
    //     .length;
    //   if (rowCount > 1) {
    //     const isFirstRow =
    //       this.newData.findIndex((item) => item.name === row.name) ===
    //       rowIndex;
    //     return isFirstRow
    //       ? { rowspan: rowCount, colspan: 1 }
    //       : { rowspan: 0, colspan: 0 };
    //   }
    // }
    //   }else{
    if (
      columnIndex === 0 ||
      columnIndex === 1 ||
      columnIndex === 2 ||
      columnIndex === 3
    ) {
      const rowCount = this.newData
        .slice((this.page - 1) * (this.size * 2), this.page * (this.size * 2))
        .filter((item) => item.name === row.name).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.newData
            .slice(
              (this.page - 1) * (this.size * 2),
              this.page * (this.size * 2)
            )
            .findIndex((item) => item.name === row.name) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public handleSelectAll(check, type) {
    if (type == "scene") {
      if (check == "open") {
        this.scene = this.smoke_scene_list;
      } else {
        this.scene = [];
      }
      this.sceneChange();
    }
    if (type == "device") {
      if (check == "open") {
        this.device = this.smoke_device_list.map((v) => v.UUID);
      } else {
        this.device = [];
      }
      this.deviceChange();
    }
    if (type == "tod") {
      if (check == "open") {
        this.tod = this.smoke_tod_device_list;
      } else {
        this.tod = [];
      }
    }
    if (type == "test_result") {
      if (check == "open") {
        this.test_result = this.text_status;
      } else {
        this.test_result = [];
      }
    }
    if (type == "problem_type") {
      if (check == "open") {
        this.problem_type = this.problem_list;
      } else {
        this.problem_type = [];
      }
    }
  }
  //  public test=2
  //  public ll=false
  //  public testse(){
  //    this.ll=true
  //   this.$nextTick(() => {
  //     // 设置<el-select>的焦点

  //     if (this.$refs.ss) {
  //       (this.$refs.ss as any).focus();
  //     }
  //   });
  //  }
  public getColor(item) {
    let color = "";
    if (item == "通过") {
      color = "#00b050";
    }
    if (item == "高优先严重") {
      color = "red";
    }
    if (item == "用例异常") {
      color = "red";
    }
    if (item == "高优先") {
      color = "orange";
    }
    if (item == "中优先") {
      color = "#F5C607";
    }
    if (item == "低优先") {
      color = "#3BB8F7";
    }
    if (item == "未测试") {
      color = "";
    }
    return color;
  }
  
  smoke_version_list = []
  async dispatchLightSmokeVersions(params) {
    const {data} = await axios(`/report/light_smoke_versions/`, {params})
    this.smoke_version_list = data
  }
  public smoke_versions_api() {
    return this.dispatchLightSmokeVersions({
      project: Number(getLocalProject()),
      light_type: 0,
    });
  }

  startEditing(rowIndex, columnName, type, image) {
    if (!image) {
      return;
    }
    if (rowIndex % 2 === 0) {
      this.editing.row = rowIndex;
      this.editing.column = columnName;
      this.editing.type = type;
    }
    this.$nextTick(() => {
      // 设置<el-select>的焦点
      const selectRef = `select-${rowIndex}-${columnName}`;
      if (this.$refs[selectRef]) {
        (this.$refs[selectRef] as any).focus();
      }
    });
  }
  public async stopEditing(data) {
    data.problem_type =
      data.result == "通过" || data.result == "未测试" ? "" : data.problem_type;
    await this.dispatchPutLightSmoke({
      project: Number(getLocalProject()),
      id: data.id,
      index: data.index,
      result: data.result,
      remark: data.remark,
      bug_url: data.bug_url,
      problem_type:
        data.result == "通过" || data.result == "未测试"
          ? ""
          : data.problem_type,
      light_type: 0,
      mark: data.mark.filter((item) => item.width !== 0 && item.height !== 0),
      ai_check: data.ai_check,
      // ai_check_res:data.ai_check_res,
    });
    this.editing.row = null;
    this.editing.column = null;
    this.editing.type = null;
  }
  public delayStopEditing(item) {
    // setTimeout(() => {
    //   this.stopEditing(item);
    // }, 0);
  }
  public remarkBtn(rowIndex, columnName, type, image) {
    if (!image) {
      return;
    }
    if (rowIndex % 2 === 0) {
      this.editing.row = rowIndex;
      this.editing.column = columnName;
      this.editing.type = type;
      this.$nextTick(() => {
        // 设置<el-select>的焦点
        console.log(this.$refs.select);
        if (this.$refs.select) {
          (this.$refs.select as any).focus();
        }
      });
    }
  }
  public bugBtn() {
    this.dispatchPutLightSmoke({
      project: Number(getLocalProject()),
      id: this.add_bug_data.id,
      index: this.add_bug_data.index,
      result: this.add_bug_data.result,
      remark: this.add_bug_data.remark,
      bug_url: this.bugModel,
      problem_type: this.add_bug_data.problem_type,
      light_type: 0,
      mark: this.add_bug_data.mark.filter(
        (item) => item.width !== 0 && item.height !== 0
      ),
      ai_check: this.add_bug_data.ai_check,
      // ai_check_res: this.add_bug_data.ai_check_res,
    });
    this.configShow = false;
    this.confirm(false);
  }
  public table_list_data = [];
  public newData = [];
  public checkChange() {
    this.$nextTick(() => {
      this.confirm(true);
    });
  }
  public labelTime(data) {
    let text = "";

    this.smoke_list?.version_list?.forEach((v) => {
      if (v.split("|")[0] === data) {
        text = v.split("|")[1];
      }
    });
    return text;
  }
  public mark_all_list = [];


  smoke_list = []
  getSmokeList(data) {
    if (data.version_list) {
      const targetIndex = data.version_list?.indexOf('PC截图')
      if (targetIndex != -1) {
        data.version_list.splice(targetIndex, 1)
        data.version_list.unshift('PC截图')
      }
    }
    return data
  }
  async dispatchLightSmokeList(params) {
    const {data} = await axios('report/light_smoke_list/', {params})
    this.smoke_list = this.getSmokeList(data)
  }

  queryTokey = ''
  async dispatchLightCommonUrl(data) {
    const res = await axios.post(`common/url/`, data)
    this.queryTokey = res.data.key
  }

  public async confirm(type, default_data?) {
    this.tableLoading = true;
    //  await  this.smoke_versions_api()
    this.table_list_data = [];
    this.img_list = [];
    this.mark_all_list = [];

    if (type) {
      this.page = 1;
      this.size = 20;
      // this.version_list = default_data
      //   ? this.version_query_list.length > 0
      //     ? this.version_query_list
      //     : this.smoke_version_list
      //         .filter((v, index) => index <= 2)
      //         .map((v) => v.version)
      //   : this.smoke_version_list
      //       .filter((v, index) => index <= 2)
      //       .map((v) => v.version);

    }

    const versionDate = (this.formData.dateVersion as string)?.split('&')
    await this.dispatchLightSmokeList({
      project: Number(getLocalProject()),
      scene: this.scene,
      device: this.device,
      version_list: this.version_list,
      tod: this.tod,
      test_result: this.test_result,
      problem_type: this.problem_type,
      light_type: 0,
      ai_check: this.ai_check,
      version: versionDate[0],
      date: versionDate[1],
    });
    this.smoke_list.screenshot_list.forEach((v) => {
      //  this.smoke_list.screenshot_list.version_list.forEach(m=>{
      //    this.smoke_list.data[m][v]
      //  })

      this.table_list_data.push({
        name: v,
        positon: v.split("|")[0],
        device: v.split("|")[2],
        scene: v.split("|")[1],
        tod: v.split("|")[3],
        img_list: Object.keys(this.smoke_list.data).map(key => this.smoke_list.data[key][v].image),
        mark_all_list: this.smoke_list.version_list.map(() => []),
        ai_check_all: [],
        ai_check_res_all: [],
        location_list_all_list: [],
        ...this.smoke_list.data,
      });
    });

    this.newData = [];
    this.newData = this.table_list_data.reduce((accumulator, currentValue) => {
      // 向累加器数组中添加两次当前值
      accumulator.push(JSON.parse(JSON.stringify(currentValue)));
      accumulator.push(JSON.parse(JSON.stringify(currentValue)));
      return accumulator;
    }, []);

    this.tableLoading = false;

    
    let params = {
      scene: this.scene.join(","),
      device: this.device.join(","),
      tod: this.tod.join(","),
      test_result: encodeURIComponent(this.test_result.join(",")),
      problem_type: encodeURIComponent(this.problem_type.join(",")),
      version_list: this.version_list.join(","),
    };
   
    const paramsString = this.generateParamsString(params);
    await this.dispatchLightCommonUrl({
      project: Number(getLocalProject()),
      url: paramsString,
    })
    
    this.$router.push({
      query: {
        ...this.$route.query,
        queryToken: this.queryTokey,
        dateVersion: this.formData.dateVersion,
      },
    });
  }
  
  
  public generateParamsString(params: any) {
    const url = new URL(window.location.href);

    // 删除queryToken参数
    url.searchParams.delete("queryToken");

    // 创建新的URL并添加新的参数
    const newParams = Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    // 返回最终的URL
    return `${url.origin}${
      url.pathname
    }?${url.searchParams.toString()}&${newParams}`;
  }
  // 加密函数
  encryptData(data, key) {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      key
    ).toString();
    return encrypted;
  }

  // 解密函数
  decryptData(encryptedData, key) {
    const bytes = CryptoJS.AES.decrypt(encryptedData, key);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  }
  public version_list = [];

  smoke_device_list = []
  async dispatchLightSmokeDevices(params) {
    const {data} = await axios('report/light_smoke_devices/', {params})
    this.smoke_device_list = data
  }
  public smoke_devices_api() {
    return this.dispatchLightSmokeDevices({
      project: Number(getLocalProject()),
      scene: this.scene,
      light_type: 0,
    });
  }

  smoke_tod_device_list = []
  async dispatchLightSmokeTodDevices(params) {
    const {data} = await axios('report/light_tod_devices/', {params})
    this.smoke_tod_device_list = data
  }
  public smoke_tod_devices_api() {
    return this.dispatchLightSmokeTodDevices({
      project: Number(getLocalProject()),
      scene: this.scene,
      device: this.device,
      light_type: 0,
    });
  }
  
  
  
  public scene: any = [];
  public device: any = [];
  public tod = [];
  // 列表过滤条件：任务名称、状态、执行者
  public name_search: string | "" = "";
  public status_search: number | "" = "";
  public user_search: string | "" = "";

  public loading = false;
  public currentPage1 = 1;
  public record = 16; //记录条数
  public async exportTable() {
    // 创建一个新的工作簿
    const workbook = new ExcelJS.Workbook();

    // 添加一个新的工作表
    const worksheet = workbook.addWorksheet("My Sheet");

    // 添加数据到工作表
    worksheet.columns = [
      { header: "测试时间", key: "date" },
      { header: "测试包", key: "pkg_name" },
      { header: "version2", key: "version2" },
    ];
    worksheet.addRows(this.get_data.results);
    worksheet.getColumn("B").alignment = { wrapText: true };
    // 获取图片的 base64 字符串
    let base64Image: any = await this.getBase64Image("../../assets/test/1.jpg");

    // 遍历数据，动态添加图片
    for (let i = 0; i < this.get_data.results.length; i++) {
      const image = await workbook.addImage({
        base64: base64Image,
        extension: "jpeg",
      });
      worksheet.getRow(i + 1).height = 300; // 设置行高为 200 像素

      worksheet.addImage(image, {
        tl: { col: 2, row: i + 1 },
        ext: { width: 300, height: 300 },
      });
      // worksheet.addImage(image, `C${i + 2}:C${i + 2}`);
    }

    // 导出工作簿
    const buffer = await workbook.xlsx.writeBuffer();
    FileSaver.saveAs(new Blob([buffer]), "exported-table.xlsx");
  }

  public getBase64Image(imgUrl) {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = require("../../assets/test/1.jpg");

      img.onload = function () {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let dataURL = canvas.toDataURL("image/jpeg");
        resolve(dataURL);
      };

      img.onerror = function () {
        reject(new Error("Could not load image at " + imgUrl));
      };
    });
  }

  dispatchSmokeByReportPut(data) {
    axios.put(`report/smoke_report_detail/${data.id}/?project=${data.projecet}`, data)
  }

  public handleEvent(data) {
    data.check = true;

    this.dispatchSmokeByReportPut({
      id: data.id,
      project: Number(getLocalProject()),
      remark: data.remark,
    });
  }
  // 任务执行状态
  public task_record_status = {
    0: "空闲",
    1: "进行中",
    2: "暂停",
    3: "完成",
    4: "取消",
    5: "异常",
  };
  public test_result = [];
  public problem_type = [];
  public text_status = [
    "通过",
    "未测试",
    "高优先严重",
    "高优先",
    "中优先",
    "低优先",
    "用例异常",
  ];
  public datePick = [];

  public defaultTime1 = [
    new Date(2000, 1, 1, 0, 0, 0),
    new Date(2000, 2, 1, 23, 59, 59),
  ];
  public status_options = [
    {
      label: "空闲",
      value: 0,
    },
    {
      label: "进行中",
      value: 1,
    },
    {
      label: "暂停",
      value: 2,
    },
    {
      label: "完成",
      value: 3,
    },
    {
      label: "取消",
      value: 4,
    },
    {
      label: "异常",
      value: 5,
    },
  ];
  // 从本地缓存获取数据
  public project = Number(getLocalProject());
  public async sceneChange() {
    await this.smoke_devices_api();
    this.device = this.smoke_device_list.map((v) => v.UUID);
    await this.smoke_tod_devices_api();
    this.tod = this.smoke_tod_device_list;
  }
  public async deviceChange() {
    await this.smoke_tod_devices_api();
    this.tod = this.smoke_tod_device_list;
  }
  public closePreview(event) {
    if (event.target.classList.contains("el-image-viewer__wrapper")) {
      (this.$refs.imagePreview as any).viewerVisible = false;
    }
  }
  public version_query_list = [];

  queryUrl = ''
  async dispatchLightCommonKey(data) {
    const res = await axios.post(`common/url/`, data)
    this.queryUrl = res.data.url
  }


  public async mounted() {
    this.loading = true;
    this.tableLoading = true;
    this.$nextTick(() => {
      const previewWrapper = document.querySelector(
        ".el-image-viewer__wrapper"
      );
      if (previewWrapper) {
        previewWrapper.addEventListener("click", this.closePreview);
      }
    });
    document.addEventListener("click", function (e: any) {
      if (e.target.className == "el-image-viewer__mask") {
        setTimeout(function () {
          let close: any = document.querySelector(".el-icon-close");
          if (close) {
            close.click();
          }
        }, 0);
      }
    });

    let test_result = [];
    let problem_type = [];
    let scene = [];
    let device = [];
    let tod = [];
    if (this.$route.query.queryToken) {
      await this.dispatchLightCommonKey({
        project: Number(getLocalProject()),
        key: this.$route.query.queryToken,
      })
      
      const parsedUrl = new URL(this.queryUrl);
      // 获取查询参数
      const params = parsedUrl.searchParams;
      test_result = params.get("test_result")
        ? decodeURIComponent(params.get("test_result")).split(",")
        : [];
      problem_type = params.get("problem_type")
        ? decodeURIComponent(params.get("problem_type")).split(",")
        : [];
      scene = params.get("scene")
        ? decodeURIComponent(params.get("scene")).split(",")
        : [];
      device = params.get("device")
        ? decodeURIComponent(params.get("device")).split(",")
        : [];
      tod = params.get("tod")
        ? decodeURIComponent(params.get("tod")).split(",")
        : [];
      this.version_query_list = params.get("version_list")
        ? decodeURIComponent(params.get("version_list")).split(",")
        : [];
    }
    this.test_result = test_result.length > 0 ? test_result : this.text_status;
    this.problem_type = problem_type.length > 0 ? problem_type : [];

    await this.smoke_scnes_api();
    this.scene = scene.length > 0 ? scene : this.smoke_scene_list;
    await this.smoke_devices_api();
    this.device =
      device.length > 0 ? device : this.smoke_device_list.map((v) => v.UUID);
    //  this.device=this.smoke_device_list.map(v=>v.UUID)
    await this.smoke_tod_devices_api();
    //  this.tod=this.smoke_tod_device_list
    this.tod = tod.length > 0 ? tod : this.smoke_tod_device_list;

    await this.smoke_versions_api();

    const routeDateVersion = this.$route.query.dateVersion
    if (routeDateVersion) {
      this.formData.dateVersion = routeDateVersion
    } else {
      this.formData.dateVersion = `${this.smoke_version_list[0].version}&${this.smoke_version_list[0].date}`
    }
    this.confirm(true, "created");


    this.loading = false;
    // this.setupCanvas();
  }

  public handleDetail(row: any, event: any, colume: any) {
    // this.$router.push({
    //     path:'/taskDetails',
    //     query:{
    //         id:row.id,
    // }})
    const { href } = this.$router.resolve({
      path: "/automated_smoke_test",
      query: {
        ...this.$route.query,
        report_id: row.id,
      },
    });
    window.open(href, "_blank");
    return Promise.resolve(false); // 不刷新表格
  }

  public get get_data() {
    readGetSmokeByReport(store)?.results?.forEach((v) => {
      v.date = dateConversion(v.create_date);
      v.check = true;
    });
    return readGetSmokeByReport(store);
  }
 
  updateMark(data, name, version, positionKey, newMarks) {
    // 遍历数据找到对应的name和version
    data.forEach((item) => {
      if (item.name === name && item[version]) {
        // 在指定版本中查找对应的positionKey
        let positionData = item[version][positionKey];
        if (positionData) {
          // 更新mark数组
          positionData.mark = newMarks;
        } else {
          console.log("No matching position found.");
        }
      }
    });
  }
}
